import React from 'react';
interface AuthorBlockProps {
  imageSrc: string;
  name: string;
  meta: string;
  className?: string;
}
export function AuthorBlock({
  imageSrc,
  name,
  meta,
  className = ''
}: AuthorBlockProps) {
  return <div className={`flex items-center gap-[14px] mb-9 pb-6 border-b border-border ${className}`} data-id="element-3">
      <img src={imageSrc} alt={name} className="w-[52px] h-[52px] rounded-full object-cover shrink-0 bg-cream border-2 border-border flex items-center justify-center text-[22px]" data-id="element-4" />
      <div className="flex flex-col gap-0.5" data-id="element-5">
        <span className="font-inter text-[14px] font-semibold text-[#111111]" data-id="element-6">
          {name}
        </span>
        <span className="font-inter text-[12px] text-[#666666]" data-id="element-7">{meta}</span>
      </div>
    </div>;
}